export const getCheckingStateByDeviceUuid = (state) => state.dashboardAccessRules.checkingStateByDeviceUuid;
export const getDisabledIds = (state) => state.dashboardAccessRules.disabledIds;
export const getErrors = (state) => state.dashboardAccessRules.errors;
export const getErrorsByDeviceUuid = (state) => state.dashboardAccessRules.errorsByDeviceUuid;
export const getIsFetching = (state) => state.dashboardAccessRules.isFetching;
export const getItems = (state) => state.dashboardAccessRules.items;
